import noSearchFound from "../../../assets/no-search-found.svg";
export const headerData = [
  {
    text: "Camapign No",
  },
  {
    text: "Title",
  },
  {
    text: "Start date",
  },
  {
    text: "End date",
  },
  {
    text: "Status",
  },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such campaigns exists. Create one?",
  imgSrc: noSearchFound,
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "campaignNumber",
    type: "",
  },
  {
    key: "title",
    type: "",
  },
  {
    key: "startDate",
    type: "",
  },
  {
    key: "endDate",
    type: "",
  },
  {
    key: "campaignStatus",
    type: "",
  },
];
